/** Arrays and nested translator trees — too irregular for locale split */
export const translatorStructured = {
	"familyStatuses": [
		{
			"name": {
				"en": "Single",
				"ru": "Одинокий",
				"hy": "Միայնակ"
			}
		},
		{
			"name": {
				"en": "Married",
				"ru": "В браке",
				"hy": "Ամուսնացած"
			}
		}
	],
	"genders": [
		{
			"name": {
				"en": "Male",
				"ru": "Мужчина",
				"hy": "Արական"
			}
		},
		{
			"name": {
				"en": "Female",
				"ru": "Женщина",
				"hy": "իգական"
			}
		}
	],
	"roles": [
		{
			"_id": "admin",
			"name": {
				"en": "Admin",
				"ru": "Администратор",
				"hy": "Ադմին"
			}
		},
		{
			"_id": "manager",
			"name": {
				"en": "Manager",
				"ru": "Управляющий",
				"hy": "Մենեջեր"
			}
		},
		{
			"_id": "editor",
			"name": {
				"en": "Editor",
				"ru": "Редактор",
				"hy": "Խմբագիր"
			}
		}
	],
	"swal": {
		"error": {
			"en": "Something went wrong!",
			"ru": "Что-то пошло не так!",
			"hy": "Ինչ-որ բան անհաջող է!"
		},
		"success": {
			"en": "Success",
			"ru": "Успех",
			"hy": "Հաջողություն"
		},
		"warning": {
			"en": "Warning",
			"ru": "Предупреждение",
			"hy": "Զգուշացում"
		},
		"info": {
			"en": "Info",
			"ru": "Информация",
			"hy": "Տեղեկություն"
		}
	}
};
